import styled from 'styled-components';

import { Box } from '../../components/Layout';

export const Container = styled.div`
    .first-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;
    }

    .premium-banner {
        background-color: var(--color-lemon);
        border-radius: 100px;
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 8px 16px;
        h6 {
            color: var(--color-neutral-darkness);
        }
        cursor: pointer;
    }

    .tracking-cards {
        margin-top: 1rem;
        > div {
            margin-bottom: 0.5rem;
        }
        > div:last-child {
            margin-bottom: 0;
        }
    }
`;

export const ActiveSection = styled.div`
    display: flex;
    align-items: center;

    > div:last-child {
        margin-top: -12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    h6 {
        margin-right: 1rem;
    }
`;

export const FooterBox = styled(Box)`
    padding: 1.5rem 0rem;
`;

export const FooterButtonSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
